import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export function InputError({
  id,
  messages,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & {
  id?: string
  messages?: string[]
}) {
  return messages ? (
    <p {...props} id={id} className={cn("text-destructive text-sm", className)}>
      {messages.join(", ")}
    </p>
  ) : null
}
